import { useFormContext } from "react-hook-form";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { misc } from "app/themes/colors";
import { BATTERY_SUBTYPE, WARRANTY_SUBTYPE } from "constants/products";
import {
  ACCESSORY_PRODUCT_TYPE,
  HEARING_AID_PRODUCT_TYPE,
  SERVICE_PRODUCT_TYPE
} from "constants/sales";

import { AddMasterProductFormValues } from "../add-master-product-form.component";
import BatterySpecificationForm from "./battery-specification-form.component";
import HearingAidSpecificationForm from "./hearing-aid-specification-form.component";
import WarrantySpecificationForm from "./warranty-specification-form.component";

const getSpecificationForm = (type: number, subtype: number) => {
  if (type === HEARING_AID_PRODUCT_TYPE) {
    return <HearingAidSpecificationForm />;
  } else if (type === SERVICE_PRODUCT_TYPE && subtype === WARRANTY_SUBTYPE) {
    return <WarrantySpecificationForm />;
  } else if (type === ACCESSORY_PRODUCT_TYPE && subtype === BATTERY_SUBTYPE) {
    return <BatterySpecificationForm />;
  }

  return null;
};

export default function SpecificationForm() {
  const { watch } = useFormContext<AddMasterProductFormValues>();

  const [type, subtype] = watch<["type", "subtype"]>(["type", "subtype"]);

  const specification = getSpecificationForm(Number(type), Number(subtype));

  if (!specification) return <Box width="100%" mb={16} />;

  return (
    <Box width="100%">
      <Typography
        variant="h5"
        component="h3"
        fontWeight={400}
        fontSize={20}
        color={misc.grayAsphalt}
        mb={2.5}
      >
        Specification
      </Typography>
      {specification}
    </Box>
  );
}
